import {observer} from "mobx-react";
import React from "react";
import {
    Container,
    CotentText,
    Text,
    TextBold,
} from "@dropDesk/presentation/components/chat_view/panel_inform_ticket_waiting/styled";

const PanelInformContactReadOnly = observer(() => {
    return (
        <Container>
            <CotentText>
                <Text>
                    <TextBold>Modo leitura:&nbsp;</TextBold>
                    visualização sem sincronização ao vivo. Se este atendimento estiver na sua fila do Chat, abra-o por
                    lá para receber e enviar mensagens. Caso contrário, peça ao responsável que transfira para você.
                </Text>
            </CotentText>
        </Container>
    );
});

export default PanelInformContactReadOnly;
